<template>
  <div class="classes-detail" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="course-content">
      <div class="course-item">
        <div class="course-img">
          <img :src="classInfo.cover" />
        </div>
        <div class="course-desc">
          <div>
            <p style="color: black; font-size: 22px">
              {{ classInfo.class_name }}
            </p>
            <p style="margin-top: 20px; color: gray">
              班级人数：<span style="color: orange">{{
                classInfo.buy_times
              }}</span>
            </p>
          </div>
          <div class="mydesc">
            班级简介：
            <div class="classdesc">
              {{ classInfo.introduction }}
            </div>
          </div>
          <!-- <div class="course-money"><span style="font-size: 20px;">￥</span>18</div>
					<div class="checkDetail">
						<span @click="tovideo" class="gotovideo">查看</span>
					</div> -->
        </div>
      </div>

      <div class="course-content-topic">
        <div class="subject-content-bottom">
          <div class="title-class" style="margin-bottom: 20px">
            <span
              style="
                                font-size: 16px;
                                background: lightblue;
                                color: white;
                                width: 100%;
                                height: 36px;
                                line-height: 36px;
                                padding-left: 20px;
                            "
              >班级考试</span
            >
          </div>
          <div class="sub-in" v-for="item in examination" :key="item.id">
            <span class="showE">{{ item.title }}</span
            ><span @click="gotoExam(item)" class="span-btn">开始考试</span>
          </div>
        </div>
        <div class="subject-content-bottom bb">
          <div class="title-class" style="margin-bottom: 20px">
            <span
              style="
                                font-size: 16px;
                                background: lightblue;
                                color: white;
                                width: 100%;
                                height: 36px;
                                line-height: 36px;
                                padding-left: 20px;
                            "
              >班级课程</span
            >
          </div>
          <!-- <el-container>
						<el-collapse v-model="activeNames" @change="handleChange">
							<el-collapse-item v-for="(item,index) in courses" :key="index"
								:title="'第'+(index+1)+'章'+ item.cap" :name="index==0?'0':index">
								<div @click="topaly(course.url,course.type)" v-for="(course,index1) in item.children"
									:key="index1" class="cc"> 第{{index1+1}}节：<span
										style="font-weight: 600;">{{course.name}}</span></div>
							</el-collapse-item>
						</el-collapse>
					</el-container> -->
          <div
            style="cursor: pointer"
            class="sub-in"
            v-for="item in courses"
            :key="item.id"
          >
            <span class="showE">{{ item.title }}</span>
            <span @click="gotoDetail(item)" class="span-btn">进入课程</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      classId: 0,
      classInfo: [],
      courses: [],
      examination: [],
      fullscreenLoading: false,
    };
  },
  created() {
    this.classId = this.$route.query.id;
    this.fullscreenLoading = true;
    this.$get("/index/Classroom/detail", {
      class_room_id: this.classId,
    }).then((res) => {
      this.fullscreenLoading = false;
      if (res.code == 200) {
        this.courses = res.data.video_edu;
        this.classInfo = res.data.classroom;
        this.examination = res.data.exam_question;
        // this.courses = res.data
      }
    });
  },
  methods: {
    tovideo() {
      alert("看视频");
    },
    handleChange(val) {},
    gotoCourse() {
      const userId = "123";
      this.$router.push({
        name: "Course_p",
        params: {
          userId,
        },
      });
    },
    gotoDetail(item) {
      this.$router.push({
        name: "Detail_p",
        query: {
          id: item.id,
        },
      });
    },
    gotoExam(item) {
      this.$router.push({
        path: "/home/subject_detail_p",
        query: {
          id: item.id,
        },
      });
    },
  },
};
</script>

<style lang="less">
.classes-detail {
  // min-height: calc(100vh - 20px);
  background-color: #f5f7fa;
  width: 1180px;
  margin: 0 auto;

  .footer {
    height: 100px;
    background-color: #091c30;
    color: lightgray;
    font-size: 14px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .top-bar {
    height: 70px;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.5);
    background-color: white;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    line-height: 70px;
    padding-left: 30px;
    padding-right: 60px;
  }

  .mydesc {
    margin-top: 10px;
    color: gray;
  }

  .classdesc {
    overflow-y: scroll;
    margin-top: 10px;
    line-height: 20px;
    text-indent: 2em;
    height: 100px;
  }

  .top-bar-title {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
  }

  .top-bar-title span {
    width: 100px;
    text-align: center;
    cursor: pointer;
  }

  .top-bar-title span:hover {
    background-color: #55aaff;
    color: white;
  }

  .login-text {
    cursor: pointer;
  }

  .course-content {
    margin-top: 20px;
    margin-bottom: 40px;
    display: flex;
    flex-direction: column;
    justify-items: center;
    justify-content: center;
    align-items: center;
    min-height: 60%;
  }

  .course-title {
    font-size: 16px;
    height: 40px;
    margin-right: 35px;
    margin-left: 10px;
    line-height: 40px;
    border: 1px solid lightgray;
    background-color: white;
  }

  .course-title span {
    width: 90px;
    height: 100%;
    text-align: center;
    background-color: deepskyblue;
    display: inline-block;
    color: white;
    font-size: 14px;
    cursor: pointer;
    position: relative;
    top: -0.5px;
  }

  .course-item {
    width: 100%;
    border: 1px solid lightgray;
    padding: 6px;
    padding-left: 20px;
    padding-right: 20px;
    height: 260px;
    position: relative;
    background-color: white;
    display: inline-block;
    margin-top: 10px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    box-sizing: border-box;
  }

  .title-class {
    height: 30px;
    line-height: 30px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    position: relative;
    top: 10px;
  }

  .nnnn {
    text-align: center;
    width: 31.8%;
    border: 1px solid rgba(0, 0, 0, 0.1);
    margin-left: 5px;
    height: 30px;
    line-height: 30px;
    background-color: white;
    color: rgba(0, 0, 0, 0.8);
    box-shadow: 1px 1px 10px 1px rgba(0, 0, 0, 0.1);
  }
  .mmm {
    text-align: center;
    width: 63.4%;
    border: 1px solid rgba(0, 0, 0, 0.1);
    margin-left: 44px;
    height: 30px;
    color: rgba(0, 0, 0, 0.8);
    background-color: white;
    line-height: 30px;
    box-shadow: 1px 1px 10px 1px rgba(0, 0, 0, 0.1);
  }

  .course-img {
  }

  .course-img > img {
    width: 275px;
    height: 217px;
    margin-top: 15px;
  }

  .course-desc {
    font-size: 14px;
    width: 75%;
    margin: 20px 0 0 15px;
  }

  .course-money {
    font-size: 40px;
    color: orange;
    margin-top: 20px;
    width: 100%;
    text-align: end;
  }

  .checkDetail {
    width: 100%;
    border-top: 1px solid rgba(0, 0, 0, 0.2);
    margin-top: 10px;
    text-align: end;
  }

  .checkDetail span {
    cursor: pointer;
  }

  .checkDetail span:hover {
    background-color: coral;
  }

  .gotovideo {
    width: 130px;
    border-radius: 5px;
    height: 40px;
    background-color: orange;
    color: white;
    font-size: 20px;
    display: inline-block;
    text-align: center;
    line-height: 40px;
    letter-spacing: 2px;
    margin-top: 20px;
    margin-right: 0px;
  }

  .el-collapse {
    width: 100%;
  }

  .course-content-topic {
    display: flex;
    width: 100%;
    min-height: 500px;
    padding-top: 20px;
    flex-direction: row;
    justify-content: space-between;
  }

  .cc {
    margin-left: 20px;
    height: 40px;
    border: 1px solid lightgray;
    line-height: 40px;
    padding-left: 10px;
    margin-top: 10px;
    margin-right: 20px;
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0.1);
  }

  .el-collapse-item__header {
    padding-left: 10px !important;
  }

  .subject-content-bottom {
    width: 50%;
    padding-right: 10px;
    font-size: 14px;
    background-color: white;
    &.bb {
      padding: 0 0 0 10px;
    }
    .sub-in {
      height: 50px;
      border-bottom: 1px solid #ddd;
      display: flex;
      justify-content: space-between;
      color: rgba(0, 0, 0, 0.6);
      padding-left: 20px;
      line-height: 50px;
      padding-right: 20px;
      &:last-child {
        border: none;
      }
      .span-btn {
        height: 30px;
        line-height: 30px;
        width: 80px;
        border-radius: 2px;
        text-align: center;
        position: relative;
        top: 10px;
        cursor: pointer;
        border: 1px solid lightgray;
      }

      .span-btn:hover {
        color: white;
        background-color: orange;
        border: 1px solid orange;
      }
    }
  }
}
</style>
